import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroImage = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, styles.containerSM])];

  // ─────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PARTNER_IMAGE_MAX_WIDTH = 440;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    maxWidth: PARTNER_IMAGE_MAX_WIDTH,
    overflow: 'hidden',
    borderRadius: theme.spacing['6'],
    borderWidth: 2,
    borderColor: theme.colors.BROWN,
  },
  containerXS: {
    aspectRatio: 1,
    width: '100%',
  },
  containerSM: {
    aspectRatio: PARTNER_IMAGE_MAX_WIDTH / 460,
    flex: 1,
  },
});
